import React from 'react';

const Lifestyle = () => (
  <div className="w-screen p-4 shadow">
    <iframe
      src="https://www.youtube.com/embed/gpPY-mqGXKs"
      title="Youtube video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      width="100%"
      height="100%"
    />
  </div>
);

export default Lifestyle;
